import React from "react";
import "./Vans.css"
import VabNavbar from "../../components/VanNavBar";
import RetinaImage from "../../components/RetinaImage";
import AutoGallery from "../../components/AutoGallery";

import {Col, Container, Row} from "react-bootstrap";

import main from "../../images/van5/main.jpg";
import main_l from "../../images/van5/main@2x.jpg";
import day_l from "../../images/van5/day@2x.png";
import night_l from "../../images/van5/night@2x.png";
import big from "../../images/van5/big.jpg";
import big_l from "../../images/van5/big@2x.jpg";
import ExpandImage from "../../components/ExpandImage";

const images = [
    '/images/van5/DSC_0006.JPG',
    '/images/van5/DSC_0013.JPG',
    '/images/van5/DSC_0017.JPG',
    '/images/van5/DSC_0018.JPG',
    '/images/van5/DSC_0021.JPG',
    '/images/van5/DSC_0029.JPG',
    '/images/van5/DSC_0032.JPG',
    '/images/van5/DSC_0035.JPG',
    '/images/van5/DSC_0037.JPG',
    '/images/van5/DSC_0043.JPG',
    '/images/van5/DSC_0048.JPG',
    '/images/van5/DSC_0051.JPG',
    '/images/van5/DSC_0055.JPG',
    '/images/van5/DSC_0058.JPG',
    '/images/van5/DSC_0061.JPG',
    '/images/van5/DSC_0072.JPG',
    '/images/van5/DSC_0086.JPG',
    '/images/van5/DSC_0093.JPG',
    '/images/van5/DSC_0101.JPG',
    '/images/van5/DSC_0132.JPG',
];

function Van5() {
    return (
        <div className="vanWrapper">
            <VabNavbar/>
            <div className="vanMain">
                <RetinaImage smallImage={main} largeImage={main_l} altText="WBR GEN 5 SWB L-KITCHEN"/>
            </div>

            <div id="intro" className="vanSection introSection">
                <Container>
                    <div className="vanTitle">WBR GEN 5 SWB L-KITCHEN</div>
                    <div className="vanModel">Toyota HiAce Generation 5 SWB L-Kitchen - Compact & Cost Effective</div>
                    <div className="vanSubText">The Toyota HiAce Generation 5 SWB L Kitchen is a fully self-contained campervan, proudly designed and built in New Zealand by WBR on the reliable Gen5 Toyota HiAce ZL SWB chassis.
                    </div>
                    <br/>
                    <div className="vanSubText">Combining affordability with efficiency, it’s an ideal option for both long road trips and everyday camper living. The layout is thoughtfully designed to balance compactness with practicality, ensuring a comfortable experience.</div>
                    <br/>
                    <div className="vanSubText">WBR offers this conversion on the Gen5 Toyota HiAce ZL model, with versatile options that include petrol or diesel engines and the choice of 2WD or 4WD configurations.</div>
                </Container>
            </div>

            <div id="layout" className="vanSection layoutSection">
                <Container>
                    <div className="vanSectionHeading">CAMPERVAN LAYOUT</div>
                    <div className="vanSubText">The Toyota HiAce SWB L Kitchen is a space-efficient adaptation of the Gen 5 L Kitchen, featuring a bed that retains the same length but is slightly narrower, paired with a more compact kitchen layout. Although its size is reduced, this setup remains fully self-contained and includes a cassette toilet for added convenience. Designed with practicality and affordability in mind, it’s an excellent choice for those seeking a well-equipped yet budget-friendly campervan for their adventures.
                    </div>
                    <br/>

                    <div className="layoutImages">
                        <Row>
                            <Col lg={6} md={12}>
                                <ExpandImage image={day_l} altText="WBR GEN 5 SWB L-KITCHEN Day Layout"/>
                            </Col>
                            <Col lg={6} md={12}>
                                <ExpandImage image={night_l} altText="WBR GEN 5 SWB L-KITCHEN Night Layout"/>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </div>

            <div className="vanSection videoSection">
                <RetinaImage smallImage={big} largeImage={big_l} altText="WBR GEN 5 SWB L-KITCHEN Inside View"/>
            </div>

            <div id="specs" className="vanSection specsSection">
                <Container>
                    <div className="vanSectionHeading">SPECIFICATIONS</div>
                    <Row>
                        <Col lg={3} md={6} xs={12}>
                            <ul>
                                <li>CHH sliding cassette toilet 24L</li>
                                <li>Sink with cold water tap and chopping board</li>
                                <li>2 burner butane hob</li>
                                <li>Fridge/freezer 65 litre 12v compressor</li>
                                <li>Double 240v power point</li>
                                <li>Redarc 200watt solar panel</li>
                                <li>Redarc 25Amp charging system, with a DC/DC charger and an MPPT solar controller</li>

                            </ul>
                        </Col>
                        <Col lg={3} md={6} xs={12}>
                            <ul>
                                <li>1 x Lithium LiFePo4 Battery with 110Ah</li>
                                <li>Interior walls lined with marine hull-liner</li>
                                <li>Dunlop foam squabs</li>
                                <li>Folding outdoor table</li>
                                <li>Smoke and Co2 detectorp</li>
                                <li>240v 30 Amp Victron mains charging system for house battery</li>
                                <li>240v Mains connection with 10-metre power cord</li>

                            </ul>
                        </Col>
                        <Col lg={3} md={6} xs={12}>
                            <ul>
                                <li>Twin USB outlet</li>
                                <li>12v LED lights throughout</li>
                                <li>Fiamma tinted roof vent with fly screen</li>
                                <li>Shurflo 12v pressure water pump</li>
                                <li>40 Litre water and 47 Litre waste tanks mounted under van</li>
                                <li>Tinted windows</li>
                                <li>Thermal backed curtains</li>

                            </ul>
                        </Col>
                        <Col lg={3} md={6} xs={12}>
                            <ul>
                                <li>Includes all certificates, Gas, Electrics, Green Card Self-containment, and Engineering</li>
                                <li>Bed measurements, 2 x 1900 x 620 singles or queen 1900 x 1520m</li>
                            </ul>
                        </Col>
                    </Row>
                </Container>
            </div>

            <div id="extras" className="vanSection extrasSection">
                <Container>
                    <div className="vanSectionAltHeading">OPTIONAL EXTRAS (AT ADDITIONAL COST)</div>
                    <div className="vanAltSubText">We provide additional features to the standard builds upon request.
                        Some of these include:
                    </div>
                    <Row>
                        <Col lg={4} md={6} xs={12}>
                            <ul>
                                <li>Tow bar square receiver</li>
                                <li>Monsoon weather shield rain protectors x 2</li>
                                <li>Mud flaps</li>
                                <li>Automatic Satelite Dish NZ SAT Mini
                                </li>
                                <li>RV Media LED Smart TV/DVD 24”</li>
                                <li>Nudge Bar in Black or Chrome</li>
                                <li>Sliding window with fly screen - Rear drivers side</li>
                                <li>Sliding window with fly screen - Rear passenger side</li>
                                <li>Fiamma 3m awning</li>
                                <li>Drivers overhead cabinet</li>
                            </ul>
                        </Col>
                        <Col lg={4} md={6} xs={12}>
                            <ul>
                                <li>Autoterm diesel cabin heater 2kw (Diesel van only)</li>
                                <li>Outdoor Shower – cold</li>
                                <li>Internet - Starlink Mini Roam (options available)	</li>
                                <li>Dometic roof vent with night blind and fly screen	</li>
                                <li>Maxxair Deluxe fan/vent power lift with remote	</li>
                                <li>Cabin fan 7”</li>
                                <li>240v RCD adapter lead</li>
                                <li>110Amp Battery Upgrade (Lithium) Total 220AH</li>
                            </ul>
                        </Col>
                        <Col lg={4} md={6} xs={12}>
                            <ul>
                                <li>Dometic inverter 350watt suitable for laptop	</li>
                                <li>Dometic inverter 800watt for ebike charging	</li>
                                <li>Dometic inverter 1600watt for airfryer	</li>
                                <li>Extra twin USB outlet</li>
                                <li>Spotlight with USB</li>

                            </ul>
                        </Col>
                    </Row>
                </Container>
            </div>

            <div id="gallery" className="vanSection gallerySection">
                <Container>
                    <div className="vanSectionBlackHeading">GALLERY</div>
                    <div className="vanBlackSubText">Tap image to enlarge.</div>
                    <AutoGallery images={images}/>
                </Container>
            </div>
        </div>

    )
}

export default Van5;